import React, { useEffect, useRef, useContext, useState } from "react";
import { NavLink } from "react-router-dom";

import Utils from "../Utils";
import ContextComponent from "../AppContext";
import { useOktaAuth } from "@okta/okta-react";
import "../../assets/css/login.css";
import LoginLeftBGImg from "../../assets/img/login-bg.png";
import LoginRightBGImg from "../../assets/img/logo-on-white-bg.png";

import {
  Container,
  Card,
  Form,
  Button,
  Modal,
  FloatingLabel,
} from "react-bootstrap";

const LoginForm = () => {
  const { oktaAuth } = useOktaAuth();
  let [canRender, setCanRender] = useState(false);

  const login = async () => {
    // await oktaAuth.signInWithRedirect({ originalUri: '/' });

    oktaAuth
      .signInWithRedirect()
      .then((res) => {
        // debugger;
        const { sessionToken } = res;
        if (res.status === "SUCCESS") {
          oktaAuth.token
            .getWithoutPrompt({
              responseType: "id_token",
              sessionToken,
            })
            .then((res) => {
              const { tokens } = res;
              console.log("tokens", tokens);

              oktaAuth.tokenManager.setTokens(tokens);
              // history.push('/dashboard');
            })
            .catch((err) => {
              console.log("err", err);
            });
        }
      })
      .catch((err) => console.log("Found an error", err));
  };

  const executeResetPassword = (e) => {
    login();
  };

  useEffect(() => {
    Utils.deleteSession();
    setCanRender(true);
  }, []);

  return (
    <>
      {canRender && (
        <Container className="vh-100 vw-100 p-0 m-0 mw-100 mh-100">
          <Card className="p-0 m-0 w-100 h-100 border-0">
            <Form className="form w-100 h-100 d-flex">
              <div className="indi-login-page-left-side h-100 w-50 overflow-hidden">
                <img
                  className="h-100 w-50"
                  src={LoginLeftBGImg}
                  alt="Welcome to our Digital Business Card Form"
                />
                <div className="vh-100 indi-login-logo-text-wrapper">
                  <div className="h-100 indi-login-logo-text align-items-center">
                    Welcome to our Digital Business Card Platform
                  </div>
                </div>
              </div>

              <div className="indi-login-page-right-side w-50 h-100">
                <div className="indi-login-page-right-top-logo">
                  <img
                    src={LoginRightBGImg}
                    className="d-flex justify-content-end"
                    alt="digital business cards"
                  />
                </div>

                <div className="indi-login-form-wrapper">
                  <div className="indi-login-form-headings text-left">
                    <div className="indi-login-form-text-login">Log in</div>

                    <div className="indi-login-form-text-desc">
                      Go to OKTA login page.
                    </div>
                  </div>

                  <div className="indi-add-footer">
                    <button
                      type="button"
                      className="btn btn-primary w-100"
                      onClick={executeResetPassword}
                    >
                      Login with OKTA
                    </button>

                    <div className="indi-login-remember-reset">
                      <div
                        className="indi-login-reset-wrapper indi-login-go-back-link"
                        role="button"
                      >
                        Other users, please click{" "}
                        <NavLink to={Utils.APP_URLS.NORMAL_LOGIN_PAGE}>
                          {" "}
                          HERE{" "}
                        </NavLink>{" "}
                        to login
                      </div>
                    </div>
                  </div>

                  {/* <div className="indi-login-form-headings text-left">
                    <div className="indi-login-form-text-desc">
                      Go to Normal login page.
                    </div>
                  </div>

                  <div className="indi-add-footer">
                    <button
                      type="button"
                      className="btn btn-primary"
                      onClick={executeResetPassword}
                    >
                      Login
                    </button>
                  </div> */}
                </div>

                <div className="indi-login-footer-wrapper">
                  <div className="indi-login-footer text-uppercase">
                    <div className="indi-login-footer-msg-1">
                      worldwide reach,
                    </div>
                    <div className="indi-login-footer-msg-2">human touch</div>
                  </div>
                </div>
              </div>
            </Form>
          </Card>
        </Container>
      )}
    </>
  );
};

export default LoginForm;
